var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.8 8.8V6.56C8.8 5.66392 8.8 5.21587 8.97439 4.87361C9.12779 4.57255 9.37256 4.32779 9.67362 4.17439C10.0159 4 10.4639 4 11.36 4H17.44C18.3361 4 18.7841 4 19.1264 4.17439C19.4274 4.32779 19.6722 4.57255 19.8256 4.87361C20 5.21587 20 5.66392 20 6.56V12.64C20 13.5361 20 13.9841 19.8256 14.3264C19.6722 14.6274 19.4274 14.8722 19.1264 15.0256C18.7841 15.2 18.3361 15.2 17.44 15.2H15.2M6.56 8.8H12.64C13.5361 8.8 13.9841 8.8 14.3264 8.97439C14.6274 9.12779 14.8722 9.37256 15.0256 9.67362C15.2 10.0159 15.2 10.4639 15.2 11.36V17.44C15.2 18.3361 15.2 18.7841 15.0256 19.1264C14.8722 19.4274 14.6274 19.6722 14.3264 19.8256C13.9841 20 13.5361 20 12.64 20H6.56C5.66392 20 5.21587 20 4.87362 19.8256C4.57256 19.6722 4.32779 19.4274 4.17439 19.1264C4 18.7841 4 18.3361 4 17.44V11.36C4 10.4639 4 10.0159 4.17439 9.67362C4.32779 9.37256 4.57256 9.12779 4.87362 8.97439C5.21587 8.8 5.66392 8.8 6.56 8.8Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.dc0c79d1d0b9e0d3b47618b3d2489acb.svg";
export { ForwardRef as ReactComponent };